import React from 'react'

type MetaAttributes = {
    [key: string]: string
}

export function parseMetaTags(metaHTML: string): React.ReactElement[] {
    const metaTagRegex = /<meta\s+([^>]+)>/gi
    const attrRegex = /([\w\-.:]+)\s*=\s*['"]([^'"]+)['"]/g

    const elements: React.ReactElement[] = []
    let tagMatch: RegExpExecArray | null

    while ((tagMatch = metaTagRegex.exec(metaHTML)) !== null) {
        const attrString = tagMatch[1]
        const attrs: MetaAttributes = {}

        let attrMatch: RegExpExecArray | null
        while ((attrMatch = attrRegex.exec(attrString)) !== null) {
            const key: string = attrMatch[1]
            const value: string = attrMatch[2]
            attrs[key] = value
        }

        const key = `${attrs.name || attrs.property || Object.values(attrs).join(':')}`
        elements.push(<meta key={key} {...attrs} />)
    }

    return elements
}
